
import { useTranslation } from 'react-i18next';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function TermsOfService() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              {t('termsOfService.heroTitle')}
            </h1>
            <p className="text-xl text-gray-600">
              {t('termsOfService.lastUpdated')}
            </p>
          </div>
        </div>
      </section>

      {/* 协议内容 */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <div className="prose prose-lg max-w-none">
            
            {/* 引言 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('termsOfService.introduction.title')}</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                {t('termsOfService.introduction.p1')}
              </p>
              <p className="text-gray-700 leading-relaxed mb-4">
                {t('termsOfService.introduction.p2')} {t('termsOfService.introduction.p3')}
              </p>
              <p className="text-gray-700 leading-relaxed mb-4">
                {t('termsOfService.introduction.p4')}
              </p>
              <p className="text-gray-700 leading-relaxed mb-4 font-semibold">
                {t('termsOfService.introduction.p5')}
              </p>
              <p className="text-gray-700 leading-relaxed">
                {t('termsOfService.introduction.p6')}
              </p>
            </div>

            {/* 定义 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('termsOfService.section1.title')}
              </h2>
              
              <ul className="list-disc pl-6 space-y-3 text-gray-700">
                <li>
                  <strong>{t('termsOfService.section1.service.term')}</strong>：{t('termsOfService.section1.service.desc')}
                </li>
                <li>
                  <strong>{t('termsOfService.section1.user.term')}</strong>：{t('termsOfService.section1.user.desc')}
                </li>
                <li>
                  <strong>{t('termsOfService.section1.content.term')}</strong>：{t('termsOfService.section1.content.desc')}
                </li>
                <li>
                  <strong>{t('termsOfService.section1.account.term')}</strong>：{t('termsOfService.section1.account.desc')}
                </li>
                <li>
                  <strong>{t('termsOfService.section1.ip.term')}</strong>：{t('termsOfService.section1.ip.desc')}
                </li>
              </ul>
            </div>

            {/* 服务说明 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('termsOfService.section2.title')}
              </h2>
              
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {t('termsOfService.section2.subsection1.title')}
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                {t('termsOfService.section2.subsection1.p1')}
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-6">
                {(t('termsOfService.section2.subsection1.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
              <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6">
                <p className="text-gray-800 font-semibold mb-2">
                  {t('termsOfService.section2.subsection1.important')}
                </p>
                <p className="text-gray-700">
                  {t('termsOfService.section2.subsection1.importantNote')}
                </p>
              </div>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {t('termsOfService.section2.subsection2.title')}
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                {t('termsOfService.section2.subsection2.p1')}
              </p>
              <p className="text-gray-700 leading-relaxed">
                {t('termsOfService.section2.subsection2.p2')}
              </p>
            </div>

            {/* 用户账户 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('termsOfService.section3.title')}
              </h2>
              
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {t('termsOfService.section3.subsection1.title')}
              </h3>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-6">
                {(t('termsOfService.section3.subsection1.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {t('termsOfService.section3.subsection2.title')}
              </h3>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                {(t('termsOfService.section3.subsection2.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>

            {/* 使用规则与限制 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('termsOfService.section4.title')}
              </h2>
              
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {t('termsOfService.section4.subsection1.title')}
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                {t('termsOfService.section4.subsection1.p1')}
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-6">
                {(t('termsOfService.section4.subsection1.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {t('termsOfService.section4.subsection2.title')}
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                {t('termsOfService.section4.subsection2.p1')}
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-6">
                {(t('termsOfService.section4.subsection2.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {t('termsOfService.section4.subsection3.title')}
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                {t('termsOfService.section4.subsection3.p1')}
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-4">
                {(t('termsOfService.section4.subsection3.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
              <p className="text-gray-700 leading-relaxed">
                {t('termsOfService.section4.subsection3.p2')}
              </p>
            </div>

            {/* 知识产权 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('termsOfService.section5.title')}
              </h2>
              
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {t('termsOfService.section5.subsection1.title')}
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                {t('termsOfService.section5.subsection1.p1')}
              </p>
              <p className="text-gray-700 leading-relaxed mb-6">
                {t('termsOfService.section5.subsection1.p2')}
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {t('termsOfService.section5.subsection2.title')}
              </h3>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-4">
                {(t('termsOfService.section5.subsection2.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
              <div className="bg-blue-50 border-l-4 border-blue-400 p-4 mb-6">
                <p className="text-gray-700">
                  <strong>{t('termsOfService.section5.subsection2.important')}</strong>
                </p>
              </div>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {t('termsOfService.section5.subsection3.title')}
              </h3>
              <p className="text-gray-700 leading-relaxed">
                {t('termsOfService.section5.subsection3.p1')}
              </p>
            </div>

            {/* 费用与支付 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('termsOfService.section6.title')}
              </h2>
              
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {t('termsOfService.section6.subsection1.title')}
              </h3>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-6">
                {(t('termsOfService.section6.subsection1.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {t('termsOfService.section6.subsection2.title')}
              </h3>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-6">
                {(t('termsOfService.section6.subsection2.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {t('termsOfService.section6.subsection3.title')}
              </h3>
              <p className="text-gray-700 leading-relaxed">
                {t('termsOfService.section6.subsection3.p1')}
              </p>
            </div>

            {/* 免责声明 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('termsOfService.section7.title')}
              </h2>
              
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {t('termsOfService.section7.subsection1.title')}
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                {t('termsOfService.section7.subsection1.p1')}
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-6">
                {(t('termsOfService.section7.subsection1.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {t('termsOfService.section7.subsection2.title')}
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                {t('termsOfService.section7.subsection2.p1')}
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                {(t('termsOfService.section7.subsection2.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>

            {/* 责任限制 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('termsOfService.section8.title')}
              </h2>
              
              <p className="text-gray-700 leading-relaxed mb-4">
                {t('termsOfService.section8.p1')}
              </p>
              
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-6">
                {(t('termsOfService.section8.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>

              <p className="text-gray-700 leading-relaxed">
                {t('termsOfService.section8.p2')}
              </p>
            </div>

            {/* 用户责任与赔偿 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('termsOfService.section9.title')}
              </h2>
              
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {t('termsOfService.section9.subsection1.title')}
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                {t('termsOfService.section9.subsection1.p1')}
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-6">
                {(t('termsOfService.section9.subsection1.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {t('termsOfService.section9.subsection2.title')}
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                {t('termsOfService.section9.subsection2.p1')}
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-6">
                {(t('termsOfService.section9.subsection2.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {t('termsOfService.section9.subsection3.title')}
              </h3>
              <p className="text-gray-700 leading-relaxed">
                {t('termsOfService.section9.subsection3.p1')}
              </p>
            </div>

            {/* 协议终止 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('termsOfService.section10.title')}
              </h2>
              
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {t('termsOfService.section10.subsection1.title')}
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                {t('termsOfService.section10.subsection1.p1')}
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-6">
                {(t('termsOfService.section10.subsection1.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {t('termsOfService.section10.subsection2.title')}
              </h3>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                {(t('termsOfService.section10.subsection2.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>

            {/* 其他条款 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('termsOfService.section11.title')}
              </h2>
              
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {t('termsOfService.section11.subsection1.title')}
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                {t('termsOfService.section11.subsection1.p1')}
              </p>
              <p className="text-gray-700 leading-relaxed mb-6">
                {t('termsOfService.section11.subsection1.p2')}
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {t('termsOfService.section11.subsection2.title')}
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                {t('termsOfService.section11.subsection2.p1')}
              </p>
              <p className="text-gray-700 leading-relaxed mb-6">
                {t('termsOfService.section11.subsection2.p2')}
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {t('termsOfService.section11.subsection3.title')}
              </h3>
              <p className="text-gray-700 leading-relaxed mb-6">
                {t('termsOfService.section11.subsection3.p1')}
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {t('termsOfService.section11.subsection4.title')}
              </h3>
              <p className="text-gray-700 leading-relaxed">
                {t('termsOfService.section11.subsection4.p1')}
              </p>
            </div>

            {/* 联系我们 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                {t('termsOfService.section12.title')}
              </h2>
              
              <p className="text-gray-700 leading-relaxed mb-4">
                {t('termsOfService.section12.p1')}
              </p>
              
              <div className="bg-gray-50 p-6 rounded-lg mb-4">
                <p className="text-gray-700 font-semibold">
                  {t('termsOfService.section12.email')}
                </p>
              </div>
              
              <p className="text-gray-700 leading-relaxed mb-2">
                {t('termsOfService.section12.p2')}
              </p>
              <p className="text-gray-700 leading-relaxed">
                {t('termsOfService.section12.p3')}
              </p>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
